import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import PrivilegedDropCreator from "@/components/waves/PrivilegedDropCreator";
import { type CurationComposerVariant, DropMode, type IdentityPickerPlacement } from "@/components/waves/dropComposer.types";
interface WaveDropCreateProps {
  readonly wave: ApiWave;
  readonly onCancel?: (() => void) | undefined;
  readonly onSuccess: () => void;
  readonly isCurationLeaderboard?: boolean | undefined;
  readonly initialCurationUrl?: string | null | undefined;
  readonly title?: string | undefined;
  readonly isModalContent?: boolean | undefined;
  readonly onExitFixedDropMode?: (() => void) | undefined;
  readonly termsSignatureFlowEnabled?: boolean | undefined;
  readonly identityPickerPlacement?: IdentityPickerPlacement | undefined;
}
export const WaveDropCreate: React.FC<WaveDropCreateProps> = t0 => {
  const $ = _c(16);
  const {
    wave,
    onCancel,
    onSuccess,
    isCurationLeaderboard: t1,
    initialCurationUrl: t2,
    title: t3,
    isModalContent: t4,
    onExitFixedDropMode: t5,
    termsSignatureFlowEnabled: t6,
    identityPickerPlacement: t7
  } = t0;
  const isCurationLeaderboard = t1 === undefined ? false : t1;
  const initialCurationUrl = t2 === undefined ? null : t2;
  const title = t3 === undefined ? "Create a New Drop" : t3;
  const isModalContent = t4 === undefined ? false : t4;
  const onExitFixedDropMode = t5 === undefined ? onCancel : t5;
  const termsSignatureFlowEnabled = t6 === undefined ? true : t6;
  const identityPickerPlacement = t7 === undefined ? "modal" : t7;
  const curationComposerVariant = isCurationLeaderboard ? "leaderboard" : "default";
  const showHeader = !isCurationLeaderboard && !isModalContent;
  let t8;
  bb0: {
    if (isModalContent) {
      t8 = "tw-mb-0";
      break bb0;
    }
    if (isCurationLeaderboard) {
      t8 = "tw-mb-4";
      break bb0;
    }
    t8 = "tw-mb-4 tw-rounded-xl tw-bg-iron-950 tw-p-4 tw-ring-1 tw-ring-inset tw-ring-iron-800";
  }
  const containerClassName = t8;
  let t9;
  if ($[0] !== onCancel || $[1] !== showHeader || $[2] !== title) {
    t9 = showHeader && <div className="tw-mb-3 tw-flex tw-items-center tw-justify-between"><span className="tw-text-base tw-font-semibold tw-text-iron-200">{title}</span>{onCancel && <button type="button" onClick={onCancel} aria-label="Close create drop" className="tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-1 tw-text-iron-400 tw-transition-all tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-iron-200"><svg className="tw-size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" /></svg></button>}</div>;
    $[0] = onCancel;
    $[1] = showHeader;
    $[2] = title;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  if ($[4] !== curationComposerVariant || $[5] !== identityPickerPlacement || $[6] !== initialCurationUrl || $[7] !== onExitFixedDropMode || $[8] !== onSuccess || $[9] !== termsSignatureFlowEnabled || $[10] !== wave) {
    t10 = <PrivilegedDropCreator wave={wave} onCancelReplyQuote={_temp} onDropAddedToQueue={_temp2} onAllDropsAdded={onSuccess} onExitFixedDropMode={onExitFixedDropMode} dropId={null} activeDrop={null} fixedDropMode={DropMode.PARTICIPATION} curationComposerVariant={curationComposerVariant} initialCurationUrl={initialCurationUrl} termsSignatureFlowEnabled={termsSignatureFlowEnabled} identityPickerPlacement={identityPickerPlacement} />;
    $[4] = curationComposerVariant;
    $[5] = identityPickerPlacement;
    $[6] = initialCurationUrl;
    $[7] = onExitFixedDropMode;
    $[8] = onSuccess;
    $[9] = termsSignatureFlowEnabled;
    $[10] = wave;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== containerClassName || $[13] !== t10 || $[14] !== t9) {
    t11 = <div className={containerClassName}>{t9}{t10}</div>;
    $[12] = containerClassName;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
};
function _temp() {}
function _temp2() {}